// Mapeia paths internos legados (EN-style usados pelos componentes existentes
// quando rodavam sob hash routing) pros paths reais do Next App Router (PT,
// neutros — SEM prefixo de locale). O prefixo de locale é aplicado depois,
// no momento de empurrar pro router (ver `withLocale` em lib/i18n.js).
//
// Permite que chamadas tipo `navigate("/catalog")` continuem funcionando sem
// reescrever cada componente — aqui no map a tradução acontece e o caller
// recebe `/pecas`, depois aplica o locale.

const EN_TO_PT = {
  "/": "/",
  "/about": "/sobre",
  "/catalog": "/pecas",
  "/services": "/servicos",
  "/sales": "/maquinas",
  "/segments": "/atuacao",
  "/contact": "/contato",
  "/careers": "/trabalhe-conosco",
  "/jobs": "/trabalhe-conosco",
  "/terms": "/termos-de-uso",
  "/cookies": "/politica-de-cookies",
  "/privacy": "/politica-de-privacidade",
};

export function mapToPtPath(path) {
  if (!path) return "/";
  const raw = String(path);
  const [pathOnly, ...rest] = raw.split("?");
  const query = rest.length > 0 ? `?${rest.join("?")}` : "";

  if (EN_TO_PT[pathOnly]) return EN_TO_PT[pathOnly] + query;

  // Slug dinâmico de produto: /product/{slug} → /produto/{slug}
  if (pathOnly.startsWith("/product/")) {
    return `/produto/${pathOnly.slice("/product/".length)}${query}`;
  }

  // Sprint 11: /produtos/{slug} foi alias intermediário antes de adotarmos
  // /{slug} (top-level canônica via /site/dynamic). Traduz aqui pra evitar
  // round-trip no redirect 308 server-side.
  if (pathOnly.startsWith("/produtos/")) {
    return `/${pathOnly.slice("/produtos/".length)}${query}`;
  }

  // Backend manda no menu o parent "Produtos" como `/produto` (singular,
  // sem slug). Essa rota não existe — só /produto/{slug} pra detalhe.
  // Manda pro listão de peças. Idem pra variantes EN.
  if (
    pathOnly === "/produto" ||
    pathOnly === "/produtos" ||
    pathOnly === "/product" ||
    pathOnly === "/products"
  ) {
    return `/pecas${query}`;
  }

  // Subcategorias do CMS (/pecas/pecas-prensas) — colapsam pro listão de
  // peças até existirem rotas dedicadas pra categoria.
  if (pathOnly.startsWith("/pecas/")) {
    return `/pecas${query}`;
  }

  // Já está em PT ou é externo — devolve como veio
  return raw;
}
